import { ExchangeBanner } from "./images";

export const ExchangeConfig = {
  banner: ExchangeBanner,
  notes: [
    "活動期間即日起至4/30止，每人限兌換乙份。數量有限兌\n完為止。LINE轉發、截圖無效。",
    "La Prairie保有最終活動解釋及調整權利。",
    "母親節預購會與首四日，恕不提供兌換。",
  ],
};
